import React, { ReactElement, useState } from "react";
import { Card, Col, Row } from "@jarvis-catalyst/ui-components";
import SearchConsentForm from "./SearchConsentForm";
import ConsentResultsTable from "./ConsentResultsTable";
import { useConsentHistory } from "../../../hooks/useConsentHistory";

type Inputs = {
  country?: string;
  business?: string;
  purposeName?: string;
  page?: number;
  limit?: number;
};

const DEFAULT_VALUES = {
  country: "",
  business: "",
  purposeName: "",
  page: 1,
  limit: 10
};

const SearchConsentPage = (): ReactElement => {
  const [form, setForm] = useState<Inputs>(DEFAULT_VALUES);
  const [showResults, setShowResults] = useState(false);
  const { consentHistoryUseQuery, setFetched } = useConsentHistory(form);

  const { data, isLoading } = consentHistoryUseQuery;

  const handleSearch = () => {
    setFetched(true);

    setShowResults(!isLoading);
  };

  return (
    <Row className="d-flex justify-content-center align-items-center">
      <Col md={12} lg={12} xs={12} sm={12}>
        <Card className="shadow">
          <h2 className="fw-bold mb-2 text-uppercase text-center">Buscar Consentimiento</h2>
          <hr />
          {!showResults ? (
            <SearchConsentForm onSearch={handleSearch} setForm={setForm} />
          ) : (
            <ConsentResultsTable
              results={data?.data.dataResult ?? []}
              onBack={() => setShowResults(false)}
              isLoading={isLoading}
            />
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default SearchConsentPage;
